<div class="card card--author card--wg">
  <a
    [routerLink]="['/network-of-experts', 'working-group', workingGroup.id]"
    class="card--author--link"
  >
    <figure class="avatar m-t-xs">
      <img
        [src]="workingGroup.image.square"
        [alt]="'photo of ' + workingGroup.name"
        *ngIf="workingGroup.image"
      />

      <img
        src="./assets/images/default-authors.svg"
        [alt]="'photo of ' + workingGroup.name"
        *ngIf="!workingGroup.image"
      />
    </figure>
  </a>
  <div class="m-t-xs m-l-colgap">
    <p class="is-bold m-b-0">
      <a
        [routerLink]="['/network-of-experts', 'working-group', workingGroup.id]"
        class="card--author--link"
        >{{ workingGroup.name }}</a
      >
    </p>
  </div>
</div>
